import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { RendaVariavelRoutesModule } from "./renda-variavel.routing";

import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgChartsModule } from "ng2-charts";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { FileUploadModule } from "ng2-file-upload";
import { provideNgxMask } from "ngx-mask";
import { BaseModule } from "../base-module/base.module";
import { CadastroBoletaExecucaoComponent } from "./boletas/cadastro-boleta-execucao/cadastro-boleta-execucao.component";
import { CadastroBoletaPendenteComponent } from "./boletas/cadastro-boleta-pendente/cadastro-boleta-pendente.component";
import { ListaBoletaPendenteComponent } from "./boletas/lista-boleta-pendente/lista-boleta-pendente.component";
import { DashRvComercialComponent } from "./dash-rv-comercial/dash-rv-comercial.component";
import { AlertDialog, DashboardOperacionalComponent } from "./dashboard-operacional/dashboard-operacional.component";
import { FiltraBasketAtivoComponent } from "./filtra-basket-ativo/filtra-basket-ativo.component";
import { FiltraBasketComponent } from "./filtra-basket/filtra-basket.component";
import { FiltraOperacaoEstruturadaComponent } from "./filtra-operacao-estruturada/filtra-operacao-estruturada.component";
import { AdicionaAtivoComponent } from "./gerador-ordem/adiciona-ativo/adiciona-ativo.component";
import { CadastroClienteAtivoComponent } from "./gerador-ordem/cadastro-cliente-ativo/cadastro-cliente-ativo.component";
import { CadastroGeradorOrdemComponent } from "./gerador-ordem/cadastro-gerador-ordem/cadastro-gerador-ordem.component";
import { GeradorOrdemListaPendenteComponent } from "./gerador-ordem/gerador-ordem-lista-pendente/gerador-ordem-lista-pendente.component";
import { GeradorOrdemListaComponent } from "./gerador-ordem/gerador-ordem-lista/gerador-ordem-lista.component";
import { GeradorOrdemStepsComponent } from "./gerador-ordem/gerador-ordem-steps/gerador-ordem-steps.component";
import { LegendaEstrategiasRvComponent } from "./legenda-estrategias-rv/legenda-estrategias-rv.component";
import { ListaBasketAtivoComponent } from "./lista-basket-ativo/lista-basket-ativo.component";
import { ListaOperacaoEstruturadaComponent } from "./lista-operacao-estruturada/lista-operacao-estruturada.component";
import { BasketService } from "./services/basket.service";
import { BoletaExecucaoService } from "./services/boleta-execucao.service";
import { DashboardService } from "./services/dashboard.service";
import { EstrategiaEstruturaService } from "./services/estrategia-estrutura.service";
import { EstrategiaService } from "./services/estrategia.service";
import { GeradorOrdemService } from "./services/gerador-ordem.service";
import { SwingTradeService } from "./services/swing-trade.service";
import { TipoBasketService } from "./services/tipo-basket.service";
import { ListaOperacaoClientesComponent } from "./swing-trade/lista-operacao-clientes/lista-operacao-clientes.component";
import { ListaOperacaoComponent } from "./swing-trade/lista-operacao/lista-operacao.component";
import { ListaPendenciaTradeComponent } from "./swing-trade/lista-pendencia-trade/lista-pendencia-trade.component";
import { UploadBasketComponent } from "./upload-basket/upload-basket.component";
import { UploadHistoricoOrdensComponent } from "./upload-historico-ordens/upload-historico-ordens.component";
import { UploadOperacaoEstruturadaComponent } from "./upload-operacao-estruturada/upload-operacao-estruturada.component";
// Migrados de clientes (Status de Operações é tela de Renda Variável):
import { ListaStatusOperacaoComponent } from "./lista-status-operacao/lista-status-operacao.component";
import { ListaClientesSemOrdemComponent } from "./lista-clientes-sem-ordem/lista-clientes-sem-ordem.component";
import { ListaIconsistenciaClienteComponent } from "./lista-iconsistencia-cliente/lista-iconsistencia-cliente.component";
import { FiltrarInconsistenciasOrdensComponent } from "./filtrar-inconsistencias-ordens/filtrar-inconsistencias-ordens.component";
import { StatusOperacaoService } from "./services/status-operacao.service";
// import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";

import { KeysPipe } from "app/shared/pipes/keys.pipe";
import { CadastroTipoBasketComponent } from "./cadastro-tipo-basket/cadastro-tipo-basket.component";
import { ListaBasketComponent } from "./lista-basket/lista-basket.component";
import { ListaDivergenciaCorretoraProsperComponent } from "./lista-divergencia-corretora-prosper/lista-divergencia-corretora-prosper.component";
import { ListaIncosistenciasComponent } from "./lista-incosistencias/lista-incosistencias.component";
import { ListaTipoBasketComponent } from "./lista-tipo-basket/lista-tipo-basket.component";
import { CadastraItemPainelComponent } from "./painel-rv/cadastra-item-painel/cadastra-item-painel.component";
import { ItensPainelComponent } from "./painel-rv/itens-painel/itens-painel.component";
import { ListaComponent } from "./painel-rv/lista/lista.component";


@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        RendaVariavelRoutesModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatTabsModule,
        MatRadioModule, 
        MatMenuModule, 
        MatChipsModule, 
        MatExpansionModule, 
        MatFormFieldModule, 
        MatRippleModule, 
        MatSortModule, 
        MatTableModule,
        FormsModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FuseWidgetModule,
        FlexLayoutModule,
        BaseModule,
        CurrencyMaskModule,
        FileUploadModule,
        NgxChartsModule,
        NgChartsModule,
        // FuseSharedModule,
        // NgxShimmerLoadingModule,
        MatBadgeModule,
        MatDialogModule
    ],
    declarations: [
        ListaBasketComponent,
        FiltraBasketComponent,
        UploadBasketComponent,
        ListaBasketAtivoComponent,
        FiltraBasketAtivoComponent,
        UploadHistoricoOrdensComponent,
        ListaOperacaoComponent,
        ListaOperacaoClientesComponent,
        ListaPendenciaTradeComponent,
        CadastroBoletaExecucaoComponent,
        GeradorOrdemListaComponent,
        CadastroGeradorOrdemComponent,
        GeradorOrdemStepsComponent,
        AdicionaAtivoComponent,
        GeradorOrdemListaPendenteComponent,
        CadastroClienteAtivoComponent,
        ListaOperacaoEstruturadaComponent,
        FiltraOperacaoEstruturadaComponent,
        UploadOperacaoEstruturadaComponent,
        DashboardOperacionalComponent,
        DashRvComercialComponent,
        ListaBoletaPendenteComponent,
        CadastroBoletaPendenteComponent,
        LegendaEstrategiasRvComponent,
        ListaIncosistenciasComponent,        
        AlertDialog,
        ListaComponent, 
        ItensPainelComponent, 
        CadastraItemPainelComponent, 
        ListaTipoBasketComponent, 
        CadastroTipoBasketComponent,
        KeysPipe,
        ListaDivergenciaCorretoraProsperComponent,
        ListaStatusOperacaoComponent,
        ListaClientesSemOrdemComponent,
        ListaIconsistenciaClienteComponent,
        FiltrarInconsistenciasOrdensComponent
    ],
    providers: [
        BasketService,
        TipoBasketService,
        SwingTradeService,
        BoletaExecucaoService,
        EstrategiaService,
        EstrategiaEstruturaService,
        GeradorOrdemService,
        DashboardService,
        StatusOperacaoService,
        provideNgxMask()
    ],
    exports: [
        ListaBoletaPendenteComponent,
        LegendaEstrategiasRvComponent
    ]
})
export class RendaVariavelModule { }
